class Woo {

    /**
     * @since 0.0.1
     * @method constructor
     */
    constructor() {
        // Initialize WC Variation Forms
        $('form.variations_form').each(function () {
            $(this).wc_variation_form();
        });

        // Lock in some data
        $('.variations_form.cart input[name="quantity"]').each(function () {

            // Lock in the max quantity
            $(this).data('max-quantity', $(this).attr('max'));

        });

        // Force the max quanity on input
        $('.variations_form.cart').on('change', 'input[name="quantity"]', function () {

            // Declare and intialize
            let max = parseInt($(this).data('max-quantity'));
            let val = parseInt($(this).val());

            // Do not allow a higher value
            if (max < val)
                $(this).val(max);

        });

        // Update the attendee questions when modal opens
        $('.attendee-questions-modal').on('show.bs.modal', function (e) {

            // Declare and initialize
            let trigger          = $(e.relatedTarget);
            let modal            = $(e.currentTarget);
            let container        = trigger.closest('.quantity-container');
            let input            = container.find('input[name="quantity"]');
            let quantity         = parseInt(input.val());
            let indicators       = modal.find('.carousel-indicators');
            let indicator        = indicators.find(':first-child').prop('outerHTML');
            let carousel         = modal.find('.carousel');
            let carouselInner    = carousel.find('.carousel-inner');
            let carouselLabel    = carousel.data('carousel-indicator-label') || 'Guest';
            let templateSelector = '[data-attendee-question-template="on"]';
            let template         = modal.find(templateSelector).val();

            // Recarousel when we open
            carousel.carousel(0);

            // If there is no template, bail out
            if (!input.length || !template)
                return;

            // Force the minimum
            quantity = Math.min(quantity, input.data('max-quantity'));

            // Add a class to identify multiple attendees
            if (quantity > 1)
                modal.addClass('has-multiple');
            else
                modal.removeClass('has-multiple');

            // Get some helper values
            let currentCount = carousel.find('.carousel-item').length;
            let adding       = quantity - currentCount > 0;

            // If we are not adding, remove some values
            if (!adding) {

                // Take the slides out
                carouselInner.find('> *:gt(' + (quantity - 1) + ')').remove();

                // Get rid of indicator nav items
                indicators.find('> *:gt(' + (quantity - 1) + ')').remove();
                indicators.find('> *:first').addClass('active');

                // Make sure the first slide is visible
                carouselInner.find('> *:first').addClass('active');

                // Recarousel it
                carousel.carousel(0);

                // That's all we are here for
                return;

            }

            // Add that many to the carousel
            for (var i = currentCount; i < quantity; i++) {

                // Create a new slide
                let markup = template.replaceAll('{{i}}', i).replaceAll('{{i+1}}', i + 1);
                let slide  = $(markup);

                // Fire up another indicator
                let nav = $(indicator).attr('data-slide-to', i)
                    .text(carouselLabel + ' ' + (i + 1)).removeClass('active');

                // Add another carousel indicator
                indicators.append(nav);
                indicators.find('> *:first').addClass('active');

                // Add the slide in there
                carouselInner.append(slide);

                // Make sure the first slide is visible
                carouselInner.find('> *:first').addClass('active');

                // Recarousel it
                carousel.carousel(0);

            }

        });

        // Prevent pressing enter to submit the ticket form
        $('.variations_form.cart').on('keydown', function (e) {
            if (e.key === 'Enter')
                e.preventDefault();
        });

        // Submit the ticket form asynchronously
        $('.variations_form.cart').on('submit', function (e) {
            // Declare and initialize
            const form      = $(this);
            const formData  = form.serialize();
            const container = form.closest('.event-tickets');
            const modal     = container.find('.modal-dialog');

            // If these are not tickets, bail
            if (!container.length)
                return;

            // Stop the presses
            e.preventDefault();

            // Start loading
            container.addClass('loading');

            // Also load the attendee info form
            if (modal.length)
                modal.addClass('loading');

            // Run the post
            $.ajax({
                type:    'POST',
                url:     wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
                data:    formData,
                success: function (response) {
                    // Assume success - reload the page
                    location.reload();
                },
                error:   function (xhr) {
                    // Tell the user something went wrong
                    alert('Error adding to cart.');

                    // Remove loading visual
                    container.removeClass('loading');

                    // Also unload the attendee info form
                    if (modal.length)
                        modal.removeClass('loading');
                }
            });

        });
    }
}

export default Woo;